module.exports = __webpack_public_path__ + "img/bg3.14aaa88a.png";